import React from "react";
import configManager from "../../singleton/ConfigManager";
import configManagerEmitter from "../../utils/configManagerEmitter";

function getConfigValue(obj, path) {
  if (typeof path === "function") {
    return path(obj);
  }

  return path.split(".").reduce((acc, key) => acc && acc[key], obj);
}

export default function withConfig(Component, configPath) {
  return function WrappedComponent(props) {
    const [configValue, setConfigValue] = React.useState(getConfigValue(configManager.config, configPath));

    React.useEffect(() => {
      const handleConfigUpdated = () => {
        setConfigValue(getConfigValue(configManager.config, configPath));
      };

      configManagerEmitter.on("configUpdated", handleConfigUpdated);
      handleConfigUpdated();

      return () => {
        configManagerEmitter.off("configUpdated", handleConfigUpdated);
      };
    }, []);

    if (configValue) {
      return <Component {...props} />;
    }
    return <></>;
  };
}
